export default __webpack_public_path__ + "static/media/jira-roadmaps_v01.62bbe8d9.gif";